import { typeCheckAppModule } from "../../../../core/utils";
import { NAME } from "./constants";
import { PaymentMethodsPage } from "./PaymentMethodsPage";

export const paymentMethodsPage = typeCheckAppModule({
    NAME,
    Container: PaymentMethodsPage,
});
